import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import MainBanner from "./components/MainBanner";
import SecondaryBanner from "./components/SecondaryBanner";
import SearchInput from "./components/SearchInput";
import CategoriesCard from "./components/CategoriesCard";
import Footer from "../../components/Footer";
// import ProvidersCarousel from "../../components/ProvidersCarousel";
import Testimonials from "../../components/Testimonials";
import HowItWorks from "./components/HowItWorks";
import EveryDayLife from "./components/EveryDayLife";
import MobileApp from "./components/MobileApp";
import FAQs from "./components/FAQs";
import { useNavigate } from "react-router-dom";
import BecomePartnerBanner from "./components/BecomePartnerBanner";
import { isMobile } from "react-device-detect";
import { Typography, Box, Stack } from "@mui/material";
import LogoImage from "../../assets/Images/Vector.png";

const HomePage = () => {
  const navigate = useNavigate();
  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem("user-info"));
  //   const userType = localStorage.getItem("user-type");
  //   if (userType == "service provider") {
  //     if (userInfo.isActive == false && userInfo.infoFilled == false) {
  //       navigate("/service-provider/info");
  //     } else if (userInfo.isActive == false && userInfo.infoFilled == true) {
  //       navigate("/service-provider/under-review");
  //     } else {
  //       navigate("/feeds");
  //     }
  //   }
  // }, []);

  // if (isMobile) {
  //   return (
  //     <Box
  //       sx={{ display: "flex" }}
  //       justifyContent="center"
  //       alignItems="center"
  //       style={{ height: "100vh" }}
  //     >
  //       <Stack direction="column">
  //         <Stack
  //           direction="row"
  //           spacing={1}
  //           alignItems="center"
  //           className="mb-5"
  //           justifyContent="center"
  //           style={{ width: "100%" }}
  //         >
  //           <img
  //             src={LogoImage}
  //             alt="logo"
  //             style={{ height: "33px", width: "50px" }}
  //           />
  //           <span
  //             className="default-color"
  //             style={{
  //               fontWeight: "bold",
  //               fontSize: "18px",
  //             }}
  //           >
  //             Amannat
  //           </span>
  //         </Stack>
  //         <Stack>
  //           <Typography>Please download the Ammanat Mobile App.</Typography>
  //         </Stack>
  //       </Stack>
  //     </Box>
  //   );
  // } else {
  return (
    <>
      <Navbar />
      <MainBanner />
      {/* <SearchInput /> */}
      <CategoriesCard />
      {/* <ProvidersCarousel /> */}
      <HowItWorks />
      <SecondaryBanner />
      <EveryDayLife />
      <MobileApp />
      <Testimonials />
      <FAQs />
      {/* <BecomePartnerBanner /> */}
      <Footer />
    </>
  );
  // }
};

export default HomePage;
